import StackAPI from '@/lib/StackAPI'
import Metrics from '../types/Metrics'
import { captureException } from '@sentry/react'

const PATH = '/partners/vendor/orders_metrics'
const API_ERROR = 'Error while fetching metrics, please try again later'
const API_INVALID_RESPONSE =
  'Invalid response from servers, please try again later'
const UNKNOWN_ERROR = 'The servers might be down, please try again later'

type ResponseData = {
  metrics: {
    open_orders: number
    open_items: number
    late_orders: number
    late_items: number
    shipped_orders: number
    shipped_items: number
    total_late_orders: number
    total_late_items: number
  }
}

type Result = {
  metrics?: Metrics
  error?: string
}

const getMetrics = async (): Promise<Result> => {
  const { get } = StackAPI()
  return get({ path: PATH })
    .then((response) => {
      if (response.status !== 200 || !response?.data) {
        return { error: API_ERROR }
      }

      return parseResult(response.data as ResponseData)
    })
    .catch((error) => {
      captureException(error)
      return { error: UNKNOWN_ERROR }
    })
}

const parseResult = (data: ResponseData): Result => {
  if (typeof data !== 'object') {
    return { error: API_INVALID_RESPONSE }
  }

  return {
    metrics: {
      openOrders: data.metrics.open_orders,
      openItems: data.metrics.open_items,
      lateOrders: data.metrics.late_orders,
      lateItems: data.metrics.late_items,
      shippedOrders: data.metrics.shipped_orders,
      shippedItems: data.metrics.shipped_items,
      totalLateOrders: data.metrics.total_late_orders,
      totalLateItems: data.metrics.total_late_items
    }
  }
}

export default getMetrics
